import React, { useState } from 'react';
import classnames from 'classnames';
import Router from 'router';
import { Icon, Input } from 'components-guide';
import { NavLogoWeb } from '..';
import { handleSearch } from 'utils/header.utils';
import Info from 'config/info';

import './NavSearchMobile.scss';

export interface NavSearchMobileProps {
    /**
     *  Invert
     */
    invert?: boolean;
    /**
     * Translate prop
     */
    t: any;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on click button
     */
    onClick?(): any;
}

const NavSearchMobile: React.FC<NavSearchMobileProps> = ({
    invert = false,
    t,
    className,
    style = {},
    onClick = () => {},
    ...props
}) => {
    const [showInput, setShowInput] = useState(false);
    const classNames = classnames(['nav-search-mobile', { invert }, className]);

    const handleOnClickLogoWeb = () => Router.push({ pathname: Info.urls.web, target: '_blank' });

    const handleToggleSearch = () => {
        setShowInput(!showInput);
        onClick();
    };

    return (
        <div className={classNames} style={style} {...props}>
            {showInput ? (
                <Input
                    id="search"
                    name="search"
                    iconLeft="x"
                    className="nav-search-mobile__input"
                    iconColor={invert ? 'white' : ''}
                    onKeyPress={handleSearch}
                    onClickLeftIcon={handleToggleSearch}
                    autoFocus
                />
            ) : (
                <div className="flex row-stretch-center">
                    <Icon
                        name="search"
                        size={20}
                        color={invert ? 'white' : ''}
                        className="nav-search-mobile__icon"
                        onClick={handleToggleSearch}
                    />
                    <NavLogoWeb invert={invert} t={t} onClick={handleOnClickLogoWeb} />
                </div>
            )}
        </div>
    );
};

export default NavSearchMobile;
